import React from "react";
import { Info, LayoutGrid, Paperclip, CheckCircle2, Check } from "lucide-react";

export const BUILDER_SECTIONS = [
  { key: "information", label: "Basic Information", icon: Info, description: "Title, summary & tags" },
  { key: "content", label: "Content", icon: LayoutGrid, description: "Build the article body" },
  { key: "attachments", label: "Attachments", icon: Paperclip, description: "Reference files" },
  { key: "review", label: "Review & Submit", icon: CheckCircle2, description: "Preview & publish" },
];

const StepBadge = ({ isActive, isDone, index }) => (
  <span
    className={`relative z-10 flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-bold border-2 ${
      isActive
        ? "bg-primary border-primary text-white"
        : isDone
        ? "bg-primary/10 border-primary text-primary"
        : "bg-surface border-border text-text_muted"
    }`}
  >
    {isDone ? <Check size={14} strokeWidth={3} /> : index + 1}
  </span>
);

// Below lg: a horizontal scrollable step bar (no room for a fixed side column).
// lg and up: the full vertical stepper with connecting line + description.
const BuilderSidebar = ({ activeSection, onSectionChange }) => {
  const activeIndex = BUILDER_SECTIONS.findIndex((s) => s.key === activeSection);

  return (
    <>
      <nav className="flex lg:hidden items-center gap-2 px-3 py-3 overflow-x-auto">
        {BUILDER_SECTIONS.map((section, i) => {
          const isActive = section.key === activeSection;
          const isDone = i < activeIndex;
          return (
            <button
              key={section.key}
              type="button"
              onClick={() => onSectionChange(section.key)}
              className={`flex-shrink-0 inline-flex items-center gap-2 pl-1.5 pr-3 py-1.5 rounded-full border ${
                isActive ? "border-primary bg-primary_tint" : "border-border bg-surface"
              }`}
            >
              <StepBadge isActive={isActive} isDone={isDone} index={i} />
              <span
                className={`text-[12px] font-semibold whitespace-nowrap ${
                  isActive ? "text-primary" : isDone ? "text-text_primary" : "text-text_secondary"
                }`}
              >
                {section.label}
              </span>
            </button>
          );
        })}
      </nav>

      <nav className="hidden lg:block w-full py-6 px-4">
        {BUILDER_SECTIONS.map((section, i) => {
          const isActive = section.key === activeSection;
          const isDone = i < activeIndex;
          const isLast = i === BUILDER_SECTIONS.length - 1;

          return (
            <button
              key={section.key}
              type="button"
              onClick={() => onSectionChange(section.key)}
              className="relative w-full flex items-start gap-3 text-left"
            >
              {!isLast && (
                <span
                  className={`absolute left-[15px] top-8 bottom-0 w-px ${isDone ? "bg-primary" : "bg-border"}`}
                />
              )}

              <StepBadge isActive={isActive} isDone={isDone} index={i} />

              <div className={`pb-7 ${isLast ? "pb-0" : ""}`}>
                <p
                  className={`text-[13px] font-semibold leading-tight ${
                    isActive ? "text-primary" : isDone ? "text-text_primary" : "text-text_secondary"
                  }`}
                >
                  {section.label}
                </p>
                <p className="text-[11px] text-text_muted mt-0.5 leading-snug">{section.description}</p>
              </div>
            </button>
          );
        })}
      </nav>
    </>
  );
};

export default BuilderSidebar;
